export { LazyInstance } from './instance.lazy';
export { LazyResolver } from './resolver.lazy';
